import { addLayerExist, removerLayerExist, getLayerExist } from './layerStatusControl'

const defaultCOLORData = [
  [0, [0, 0, 255]],
  [12.5, [20, 255, 170]],
  [25, [90, 255, 45]],
  [37.5, [255, 45, 45]],
  [50, [255, 12, 147]],
  [62.5, [255, 100, 252]],
  [75, [247, 160, 245]],
  [87.5, [255, 218, 254]],
  [100, [255, 255, 255]]
]

function getInColor (valueAfter, valuebefore, value, RGBAfter, RBGbefore) {
  var RGBSP = RGBAfter - RBGbefore
  var newRgb = (RGBSP / (valueAfter - valuebefore)) * (value - valuebefore) + RBGbefore
  newRgb = parseInt(newRgb)
  if (Math.abs(newRgb) > 255) {
    console.log('err')
  }
  return newRgb
}

function getColorList(COLORData) {
  // 渐变值为100
  var STEP = 101
  var MinValue = COLORData[0][0]
  var MaxValue = COLORData[COLORData.length - 1][0]
  // 计算单位值
  var colorStepSacleValue = (MaxValue - MinValue) / (STEP - 1)
  var indexValue = 0
  var colorList = []
  for (var i = 0; i < 100; i++) {
    var countValue = MinValue + colorStepSacleValue * i
    if (countValue > COLORData[indexValue + 1][0]) {
      indexValue++
    }
    if (countValue >= COLORData[COLORData.length - 1][0] || indexValue === COLORData.length - 1) {
      break
    }
    var minValue = COLORData[indexValue][0]
    var maxValue = COLORData[indexValue + 1][0]
    var minRgb = COLORData[indexValue][1]
    var maxRgb = COLORData[indexValue + 1][1]
    var colorR = getInColor(maxValue, minValue, countValue, maxRgb[0], minRgb[0])
    var colorG = getInColor(maxValue, minValue, countValue, maxRgb[1], minRgb[1])
    var colorB = getInColor(maxValue, minValue, countValue, maxRgb[2], minRgb[2])
    var colorStep = {
      KeyValue: countValue,
      RGB: 'rgb(' + colorR + ', ' + colorG + ', ' + colorB + ')'
    }
    colorList.push(colorStep)
  }
  var MAXCOLOR = COLORData[COLORData.length - 1][1]
  colorList.push({
    KeyValue: COLORData[COLORData.length - 1][0],
    RGB: 'rgb(' + MAXCOLOR[0] + ', ' + MAXCOLOR[2] + ', ' + MAXCOLOR[2] + ')'
  })
  return colorList;
}

function getWindOptions(_params) {
  let data = defaultCOLORData;
  const params = _params.params;
  if (params.COLORData && params.COLORData.length) {
    data = params.COLORData;
  }
  const colorList = getColorList(data);
  const windOptions = {
    colorScale: (m) => {
      if (!params.isColorful) {
        return 'rgb(255, 255, 255)';
      }
      const indexMax = colorList.length;
      if (m <= colorList[0].KeyValue) {
        return colorList[0].RGB
      }
      if (m >= colorList[indexMax - 1].KeyValue) {
        return colorList[indexMax - 1].RGB
      }
      for (let i = 0; i < indexMax - 1; i++) {
        if (m >= colorList[i].KeyValue && m < colorList[i + 1].KeyValue) {
          return colorList[i].RGB
        }
      }
      return 'rgb(255,255,255)';
    },
    frameRate: params.frameRate || 64,
    maxAge: params.maxAge || 60,
    globalAlpha: params.globalAlpha || 0.9,
    velocityScale: params.velocityScale || 0.01,
    lineWidth: params.lineWidth || 1.8,
    paths: params.paths || 5000,
  }
  return windOptions;
}

let windLayer;
function addWindLayer (params, viewer) {
  let layer;
  $.ajax({
    url: params.url,
    async: false,
    success: function (res) {
      const windOptions = getWindOptions(params);
      windLayer = new CesiumWind.WindLayer(res, {windOptions});
      windLayer.addTo(viewer);
      const addInfo = {
        info: params,
        layer: params,
        market: null,
      }
      addLayerExist(addInfo);
    }
  })
}

function removeWindLayer (params) {
  const info = getLayerExist(params);
  if (windLayer && info) {
    removerLayerExist(info.info);
    windLayer.removeLayer();
  }
}

export {
  addWindLayer, removeWindLayer
}
